module.exports = __webpack_public_path__ + "img/Construborges.07de29cc.png";